import React, { useEffect } from "react";
import i18n from "../../i18n/config";
import { useHistory } from "react-router-dom";
import { ROUTES } from "../../constants/clientRoutes";
import { ALLOCATION_TYPES } from "../../constants/enums";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../types/redux";
import { AllocationType } from "../../types/api/allocations";
import { WizardChildProps } from "../../types/props";
import { SetRemainingAmountAllocation } from "../../actions/allocations";

const RemainingAmount = (props: WizardChildProps) => {
  const { setTitle, setForwardButton } = props;
  const history = useHistory();
  const dispatch = useDispatch();
  const [selectedAccount, setSelectedAccount] = React.useState<string>();
  const { selectedAllocations, allocationsToSubmit } = useSelector((state: RootState) => state.allocations);
  const initialForwardButtonState = {
    text: i18n.t("COMMON.NEXT"),
    disabled: true,
    onClick: () => handleClick()
  }

  const allocationsToDisplay = selectedAllocations.filter((allocation: AllocationType) => allocation.id !== allocationsToSubmit?.[0].id);

  useEffect(() => {
    setTitle(i18n.t("PAGES.ALLOCATIONS.REMAINING_AMOUNT.TITLE"));
    setForwardButton(initialForwardButtonState);
  }, []);

  useEffect(() => {
    if (selectedAccount) {
      setForwardButton({
        ...initialForwardButtonState,
        disabled: false
      });
    }
  }, [selectedAccount]);

  const handleClick = () => {
    const mutableAllocations = selectedAllocations.map((allocation: AllocationType) => ({ ...allocation }));
    const selectedAllocation = mutableAllocations.find((allocation: AllocationType) => allocation.id === Number(selectedAccount));
    selectedAllocation.percentage = 100;
    selectedAllocation.fixed = 0;
    dispatch(SetRemainingAmountAllocation(selectedAllocation));
    history.push(ROUTES.ALLOCATIONS.CONFIRMATION, { type: ALLOCATION_TYPES.FIXED });
  }

  return (
    <>
      <p>{i18n.t("PAGES.ALLOCATIONS.REMAINING_AMOUNT.RADIO_BUTTONS_HEADING")}</p>

      <div className="radio-btns allocation">
        {allocationsToDisplay.map((allocation: AllocationType) => (
          <label htmlFor={String(allocation.id)} key={allocation.id}>
            <span className="sr-only">{allocation.accountName} {allocation.name}</span>
            <input
              type="radio"
              id={String(allocation.id)}
              value={String(allocation.id)}
              name="allocations"
              onChange={(e) => setSelectedAccount(e.target.value)}
            />
            <span className="radio__label">
              <span className="spacing-left-xs">{allocation.accountName}</span>
              <br />
              <span className="italic">{allocation.name}</span>
            </span>
          </label>
        ))}
      </div>

      <p className="bold">{i18n.t("PAGES.ALLOCATIONS.REMAINING_AMOUNT.DISCLAIMER")}</p>
    </>
  );
}

export default RemainingAmount;